// Copyright © 2017-2019  SDG Systems, LLC. All rights reserved.
// This file may not be used in any form without the express written permission of SDG Systems, LLC.

<template>
  <v-container fluid grid-list-md>
    <v-layout row wrap>
      <v-flex xs12 justify-center>
        <item-list
        allowAdd
        allowDelete
        :endpoint="endpoint + 'locationtags'"
        editRoute="locationtagEdit"
        :filter="filters"
        :headers="headers"
        id="_id"
        name="Location Tag"
        permissions="locationtags"
        :searchBarText="searchBarText"
        pagination
        ></item-list>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import { mapGetters } from 'vuex'

import {ENDPOINT} from '@/shared/constants'
import ItemList from '@sdgsystems/vue-common/components/ItemList.vue'

export default {
  components: {
    ItemList
  },

  props: {
    searchBarText: String
  },

  data () {
    return {
      endpoint: ENDPOINT,
      headers: [
        {
          text: 'Name',
          value: 'name',
          sortable: true
        },
        {
          text: 'Tag',
          value: 'tag',
          sortable: true
        },
        {
          text: 'Coordinates',
          value: 'xycoordinates',
          sortable: true
        },
        {
          text: 'Zone',
          value: 'zone',
          context: ENDPOINT + 'zones?limit=1000',
          function: this.getZoneName,
          sortable: false
        }
      ]
    }
  },

  computed: {
    ...mapGetters([
      'filters'
    ])
  },

  methods: {
    getZoneName: function (item, list) {
      if (item.zone) {
        if (item.zone !== '' && list) {
          var zone = list.find((el) => el._id === item.zone)
          if (zone) {
            return zone.name
          }
        }
      }
      return 'N/A'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/LocationTags.vue